module.exports = __webpack_public_path__ + "images/category_lp/brand/new/store_images/4@2x_879e40829142922f39dd35f0a30bcdfa.png";